// Footer.js

import SocialMediaIcons from "../../02-molecules/socialMediaIcons/SocialMediaIcons";

import { Link } from "react-router-dom";

const Footer = () => {

    const toggleAccordion = (event) => {
        event.target.classList.toggle('open');
    }

    return (
    <footer className="footer">
        <div className="wrapper">
            <div className="footer-container">
                <div className="footer-about">
                    <div className="footer-about__company">
                        <h4 onClick={toggleAccordion}>Our Company</h4>
                        <ul>
                            <Link to="/about-us">
                                <li>About Us</li>
                            </Link>

                            <Link to="/FAQs">
                                <li>FAQs</li>
                            </Link>

                            <Link to="/testimonials">
                                <li>Testimonials</li>
                            </Link>
                        </ul>
                    </div>

                    <div className="footer-about__services">
                        <h4 onClick={toggleAccordion}>Our Services</h4>
                        <ul>
                            <li>Layout Services</li>
                            <li>BeSpoke Services</li>
                            <li>Interior Decor</li>
                            <li>Assembly Services</li>
                        </ul>
                    </div>

                    <div className="footer-about__call">
                        <h4>Call Us</h4>
                        <ul>
                            <li>
                                <i className="fas fa-phone-alt" aria-hidden="true"></i> <a href="tel:+91 9650165000" target="_blank" rel="noopener noreferrer">+91 96501-65000</a> / <a href="tel:+91 98111-45045" target="_blank" rel="noopener noreferrer">+91 98111-45045</a>
                            </li>

                            <li>
                                <a href="mailto:ajitfurniture33@yahoo.com" target="_blank" rel="noopener noreferrer"><i className="fa-solid fa-envelope" aria-hidden="true"></i><span className="sr-only">Send email to Ajit Furniture House</span>ajitfurniture33@yahoo.com</a>
                            </li>

                            <li className="clock">
                                <i className="fa-regular fa-clock"></i>
                                10.30 am to 9:00 pm IST, Tuesday-Sunday
                            </li>
                        </ul>
                    </div>

                    <div className="footer-about__visit">
                        <h4>Visit Our Store</h4>

                        <a href="https://g.page/ajitfurniturehouse" target="_blank" rel="noopener noreferrer"><i className="fas fa-map-marker-alt" aria-hidden="true"></i>Get Directions</a>
                    </div>
                    
                    <div className="footer-about__enquiry">
                        <h4>Get in Touch</h4>
                        {/* <i className="fa-regular fa-clock"></i> */}
                        <i className="fa-solid fa-envelope" aria-hidden="true"></i><span className="sr-only">Send enquiry to Ajit Furniture House</span>
                        <Link to="/contact">Send Enquiry</Link>
                    </div>
                </div>

                <div className="footer-socials">
                    <div className="footer-socials__follow">FOLLOW US ON</div>
                    <SocialMediaIcons isFooter={true}/>
                </div>

                <div className="footer-copywright">Copyright © 2024 Ajit Furniture House. All rights reserved</div>
            </div>
        </div>
    </footer>
    )
}

export default Footer;